const Default = ({ project }) => {
  return <div>No tracer found</div>;
};

export default Default;
